module.exports = __webpack_public_path__ + "doctor_8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_8.jpg
// module id = 895
// module chunks = 0